import React, { useState , useEffect} from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { DropdownButton, Dropdown } from 'react-bootstrap';


// const coreui = require('@coreui/coreui')
// import coreui from '/js/dist/*.js'
// import coreui from '../../node_modules/@coreui/coreui/js/dist/*.js'

function NameGeneratorNew() {
  const [input, setInput] = useState('');
  const [errorDisplay, setErrorDisplay] = useState('');
  const [filteredNewNames, setFilteredNewNames] = useState([]);
  const [gender, setGender] = useState('0');
  const [selectedOption, setSelectedOption] = useState('start');
  const [error, setError] = useState(false);
  const [category, setCategory] = useState(''); // State for category selection
  const [loading, setLoading] = useState(false);
  const [dropDownCategories, setDropDownCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('English');
  useEffect(() => {
    // Fetch category names from the custom API endpoint
    axios.get('https://nameoutline.com/wp-json/custom/v1/categories')
        .then(response => {
            // Update state with category names
            setDropDownCategories(response.data);
        })
        .catch(error => {
            console.error('Error fetching categories:', error);
        });
    }, []); // Empty dependency array to run the effect only once on component mount
  
//   useEffect(() => {
//     const categoryValue = document.getElementById('name-generator').getAttribute('data-category');
//     setCategory(categoryValue);
// }, []);
useEffect(() => {
  const categoryValue = document.getElementById('name-generator').getAttribute('data-category');
  if (categoryValue) {
    // Hide the dropdown container if the categoryValue exists
    const dropdownContainer = document.querySelector('.dropdown-container');
    const genderSelectorContainer = document.querySelector('.gender-selector');
    if (dropdownContainer || genderSelectorContainer) {
        dropdownContainer.style.display = 'none';
        genderSelectorContainer.style.display = 'none';
    }
  }
  setCategory(categoryValue || selectedCategory); // Set category to attribute value or empty string if attribute not found

}, [selectedCategory]);
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  }

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const generateNewNames = () => {
    
    if (!input) {
      return setErrorDisplay("Enter keyword!");
    }
    const siteURL =window.location.hostname
    // Update the URL with your actual endpoint
    // const apiUrl = `https://nameoutline.com/wp-json/custom/v1/names?keyword=${input}&gender=${gender}&selectedPosition=${selectedOption}`;
    
    setLoading(true);
    // const apiUrl = `https://nameoutline.com/wp-json/custom/v1/names?keyword=${input}&gender=${gender}&selectedPosition=${selectedOption}`;

    const apiUrl = `https://nameoutline.com/wp-json/custom/v1/names?keyword=${input}&gender=${gender}&selectedPosition=${selectedOption}&category=${category}`;

    axios.get(apiUrl)
      .then(response => {
        const names = response.data;
        if (names.length === 0) {
          setError(true);
          setLoading(false);
          setFilteredNewNames([]);
        } else {
            
          setError(false);
          setLoading(false);
          const newFiltered = names.filter((name) =>
          name.toLowerCase().includes(input.toLowerCase())
       
            );
         let filteredResult;  
        switch (selectedOption) {
        case 'start':
            filteredResult = newFiltered.filter(name => name.toLowerCase().startsWith(input.toLowerCase()));
            console.log(filteredResult)
            if(filteredResult == []){
              setError(true)
              setLoading(false);
              setErrorDisplay("Names not found!")
            }
            else{
              setErrorDisplay("")
            }
            break;
        case 'middle':
            filteredResult = newFiltered.filter(name => name.toLowerCase().includes(input.toLowerCase()));
            console.log(filteredResult)
            if(filteredResult == []){
              setError(true)
              setLoading(false);
              setErrorDisplay("Names not found!")
              
            }
            else{
              setErrorDisplay("")
            }
            break;
        case 'end':
            filteredResult = newFiltered.filter(name => name.toLowerCase().endsWith(input.toLowerCase()));
            console.log(filteredResult)
            if(filteredResult == []){
              setError(true)
              setErrorDisplay("Names not found!")
              setLoading(false);
            }
            else{
              setErrorDisplay("")
            }
            break;
        default:    
            filteredResult = newFiltered;
        }
        
        setErrorDisplay('');
        setFilteredNewNames(filteredResult);
        //   setFilteredNewNames(names);
        }
        setErrorDisplay('');
      })
      .catch(error => {
        console.error("There was an error fetching the names:", error);
        setErrorDisplay("Failed to fetch names. Please try again.");
      });
  }
  const handleCategorySelect = (category) => {  
    // Update selected category state when a category is selected
    setSelectedCategory(category);
    if(category === "Story"){
        const genderRadio = document.getElementsByClassName('gender-radio-btn');
        for(let i = 0 ; i<genderRadio.length; i++){
          genderRadio[i].disabled = true
        }
        setGender('0')
    }else if (category === "Animal"){
      const genderRadio = document.getElementsByClassName('gender-radio-btn');
      for(let i = 0 ; i<genderRadio.length; i++){
        genderRadio[i].disabled = true
      }
        setGender('0')
    }
    else{
      const genderRadio = document.getElementsByClassName('gender-radio-btn');
      for(let i = 0 ; i<genderRadio.length; i++){
        genderRadio[i].disabled = false
      }
    }
};

  // Component JSX remains largely unchanged, except for error handling and data presentation
  // const categoryValueForHeading = document.getElementById('name-generator').getAttribute('data-category');
  return (
    <div>
      <h1>{category ? category : selectedCategory} Name Generator</h1><br/>
      <input
        type="text"
        placeholder="Enter keyword"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ccc' }} // Apply styles here
      /><br/>
      <span style= {{color: 'red',fontSize: '14px'}}>{errorDisplay}</span><br/>

      <div className="dropdown-container">
        <label htmlFor="dropdown-basic-button" className='dropdown-label'>Select Category:</label>
        <DropdownButton id="dropdown-basic-button" title={selectedCategory} style={{ width: '120px' }}>
          {dropDownCategories.map((category, index) => (
              <Dropdown.Item key={index} onClick={() => handleCategorySelect(category)}>
                  {category}
              </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
      
      <div style={{marginBottom: '10px', marginTop: '10px'}}>
        <h4 style={{  fontSize: '20px' }}>Name Filter </h4>
        {/* Add inline styles to your labels and inputs as needed */}
        <label style={{ marginRight: '10px' }}>
          <input
            type="radio"
            value="start"
            checked={selectedOption === 'start'}
            onChange={handleOptionChange}
            
          />
          Start with
        </label>

        <label style={{ marginRight: '10px' }}>
          <input
            type="radio"
            value="middle"
            checked={selectedOption === 'middle'}
            onChange={handleOptionChange}
          />
          Contains
        </label>

        <label>
          <input
            type="radio"
            value="end"
            checked={selectedOption === 'end'}
            onChange={handleOptionChange}
          />
          End with
        </label>
      </div>
      <div className='gender-selector'>
        <h4 style={{fontSize : '20px' }}>Gender Selector</h4>

        <label style={{ marginRight: '10px' }}>
          <input
            type="radio"
            value="0"
            checked={gender === '0'}
            onChange={handleGenderChange}
            className='gender-radio-btn'
          />
          Male
        </label>

        <label>
          <input
            type="radio"
            value="1"
            checked={gender === '1'}
            onChange={handleGenderChange}
            className='gender-radio-btn'
          />
          Female
        </label>
      </div>
      {/* <button style={{ marginTop: '10px', padding: '8px 15px', backgroundColor: '#007bff', color: '#fff', borderRadius: '5px', border: 'none' }} onClick={generateNewNames}>
        Generate Names
      </button> */}
      
      <Button variant="primary" disabled={loading} onClick = {generateNewNames} style={{ marginTop: '10px', padding: '8px 15px', backgroundColor: '#007bff', color: '#fff', borderRadius: '5px', border: 'none' }}>
        {loading && (
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{ marginRight: '5px' }}
          />
        )}
        {loading ? 'Loading...' : 'Generate Names'}
      </Button>

      {/* <div>{data}</div> */}

      {error ? <p style={{ color: 'red', marginTop: '30px' }}>Names not found</p> : (
        <ul style={{ listStyleType: 'none', marginTop: '30px', padding: '0' }}>
          {filteredNewNames.map((name, index) => (
            <React.Fragment key={index}>
              {index > 0 && index % 10 === 0 && <br />} {/* Add a line break after every 10th element */}
              <li style={{ display: 'inline', marginRight: '5px' }}>{name}{index < filteredNewNames.length - 1 && ','}</li> {/* Display inline with comma separation */}
            </React.Fragment>    
          ))}
        </ul>
      )}
    </div>
  );
}

export default NameGeneratorNew;
